import { Button } from '@/components/ui/button';
import { PopoverArrow, PopoverContent } from '@/components/ui/popover';
import { useTranslation } from 'react-i18next';

interface Props {
  onOk: () => void;
}

export function SignInBeforeJoinPopoverContent({ onOk }: Props) {
  const { t } = useTranslation();

  return (
    <PopoverContent side="bottom" align="end" className="w-80 p-4 bg-indigo-200 rounded-xl text-[14px] leading-[20px]">
      <div className="flex items-start gap-2 mb-4">
        <div>
          <p className="font-medium text-[16px] mb-2">{t('conference.signInHint.title')}</p>
          <p>{t('conference.signInHint.description')}</p>
        </div>
      </div>

      <div className="flex justify-end">
        <Button
          onClick={onOk}
          className="px-8 h-10 rounded-3xl border-none bg-indigo-500 text-white hover:bg-indigo-600 font-medium"
        >
          {t('conference.signInHint.ok')}
        </Button>
      </div>

      <PopoverArrow className="w-6 h-4 fill-indigo-200" />
    </PopoverContent>
  );
}
